/**
 * 复制文本
 * @param options
 */
export async function copy(text: string): Promise<boolean> {
  const isSupportClipboard = navigator && 'clipboard' in navigator
  try {
    if (isSupportClipboard) {
      await navigator!.clipboard.writeText(text)
      return true
    } else {
      // 兼容性方案
      const textArea = document.createElement('textarea');
      textArea.value = text;
      // 防止滚动
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      const success = document.execCommand('copy');
      document.body.removeChild(textArea);

      if (!success) {
        return false
      }
      return true
    }
  } catch (e) {
    console.error('Copy failed:', e)
    return false
  }
}

export function isMemeShotApp() {
  const userAgent = navigator.userAgent.toLowerCase()
  const d = /(memeshotapp)/i
  return d.test(userAgent)
}

export function isAndroid() {
  const userAgent = navigator.userAgent
  return userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1 // android终端
}
export function isIOS() {
  const userAgent = navigator.userAgent
  return !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
}

export function formatNumber(value: any, decimals = 2, showUnit = true) {
  if (value === null || value === undefined) return '-'
  const units = ['', 'K', 'M', 'B', 'T']
  let unitIndex = 0
  let scaledValue: any = Math.abs(value)
  while (scaledValue >= 1000 && unitIndex < units.length - 1) {
    unitIndex += 1
    scaledValue /= 1000
  }

  // 处理小数位数

  scaledValue = scaledValue.toFixed(decimals)

  // 去除末尾多余的0和小数点

  scaledValue = parseFloat(scaledValue)

  return value < 0
    ? `-${scaledValue}${showUnit ? units[unitIndex] : ''}`
    : `${scaledValue}${showUnit ? units[unitIndex] : ''}`
}

export function formatMarketCap(value: any) {
  if (!value) return '- -'

  return `$${formatNumber(value)}`
}

/**
 * 获取代币地址
 * @param {string} str
 * @returns {any}
 */
export function formatAddress(str: string, startWidth = 5, endWidth = 5) {
  if (str && str.length > startWidth + endWidth) {
    const reg = new RegExp(
      '^(\\S{' + startWidth + '})(.*)(\\S{' + endWidth + '})$',
    )
    return str.replace(reg, '$1...$3')
  }
  return str
}

/**
 * @description 千分位以逗号隔开
 * @param {number | null} n - 待格式化的数字
 * @returns {string} - 格式化后的字符串或 "--"
 */
export function formatNumberWithCommas(n: number | null): string {
  // 如果n为null，返回"--"
  if (n === null || n === undefined) {
    return '--'
  }

  const num: string = (n || 0).toString()
  let number: number = 0,
    floatNum: string = '',
    intNum: any = []

  // 判断是否有小数位，有则截取小数点后的数字
  if (num.indexOf('.') > 0) {
    number = num.indexOf('.') // 获取小数点出现的位置
    floatNum = num.substr(number) // 截取小数点后的部分
    intNum = num.substring(0, number) // 截取小数点前的部分
  } else {
    intNum = num
  }

  // eslint-disable-next-line prefer-const
  let result: string[] = [],
    counter: number = 0

  intNum = intNum.split('')

  // 利用3的倍数，向数组插入','
  for (let i = intNum.length - 1; i >= 0; i--) {
    counter++
    result.unshift(intNum[i])
    if (!(counter % 3) && i != 0) {
      result.unshift(',')
    }
  }

  return result.join('') + floatNum || ''
}

/**
 * @description 将数字转换为百分比格式
 * @param {number | null} n - 待转换的数字
 * @returns {string} - 百分比字符串或 "--"
 */
export function formatPercentage(n: number | null): string {
  // 如果n为null或undefined，返回"--"
  if (n === null || n === undefined) {
    return '--'
  }
  const percentage: number = n * 100
  return percentage % 1 === 0 ? `${percentage.toFixed(0)}%` : `${percentage}%`
}
